import { setContext } from 'apollo-link-context';

export const withHeaders = (
  headers:
    | { [key: string]: string }
    | ((previousContext: Record<string, any>) => { [key: string]: string })
) =>
  setContext((_, previousContext) => ({
    ...previousContext,
    headers: {
      ...(typeof headers === 'function' ? headers(previousContext) : headers),
      ...previousContext.headers,
    },
  }));
